(ns bleene.layout.panes-manager
  (:require
   [bleene.dag.core :as fl.dag]
   [bleene.utils :as utils]
   [lucide-react :refer [Plus X]]
   [re-frame.core :as re-frame]
   [react-hotkeys-hook :refer [useHotkeys]]
   [ui.button :as button]
   [ui.tabs :refer [trigger-class]]
   [ui.utils :refer [clsx]]))


(defn editor-pane [{:keys [pane-id]}]
  (let [{:keys [tabs active-tab]}
        (utils/query {:tabs       [:panes pane-id {:tabs [:tabs]}]
                      :active-tab [:panes pane-id :active-tab]})

        set-tab (fn [id]
                  (let [id (if (= "default-dag" id)
                             :default-dag
                             id)]
                    (when-not (= id active-tab)
                      (re-frame/dispatch [:dag/open-context-menu false])
                      (re-frame/dispatch [:dag/set-sources-on-dag id true])
                      (re-frame/dispatch [:dag/full-layout id])
                      (re-frame/dispatch [:layout/set-active-tab pane-id id]))))]

    (useHotkeys "alt+right" #(re-frame/dispatch [:layout/focus-tab pane-id :next]))
    (useHotkeys "alt+left" #(re-frame/dispatch [:layout/focus-tab pane-id :prev]))

    [:div {:class "flex flex-col h-full"}
     [:div {:class "flex"}
      [ui.tabs/tabs-root {:value           active-tab
                          :on-value-change set-tab
                          :class           "min-w-0 h-full overflow-hidden flex-1 relative"
                          :activation-mode "manual"}
       [ui.tabs/tabs-list {:variant :overlined
                           :size    :small
                           :class   "overflow-x-auto scrollbar-thin"}
        (for [{:keys [id name]} tabs]
          ^{:key id}
          [ui.tabs/tabs-trigger {:value   id
                                 :variant :overlined
                                 :class   "gap-2 px-3 font-normal text-xs group shrink-0"}
           (if (= id :default-dag)
             "Pipelines"
             name)
           
           (when (not= id :default-dag)
             [button/button {:size          :icon-xs
                             :icon          X
                             :variant       :empty-transparent
                             :component     :div
                             :title         "Close tab"
                             :class         "rounded-full transition-all opacity-0 group-hover:opacity-100 -ml-1 -mr-2"
                             :on-mouse-down (fn [e]
                                              (.stopPropagation e)
                                              (re-frame/dispatch [:layout/close-tab pane-id id]))}])])
        [:button {:on-click #(re-frame/dispatch [:layout/add-new-tab pane-id])
                  :class    (clsx (trigger-class {:variant :overlined})
                                  "py-1.5 font-medium px-3 group sticky right-0")}
         [:> Plus {:size 20}]]]]]

     (into [:div {:class "grow"}]
           (for [{:keys [id name]} tabs]
             ^{:key id}
             [:div {:class ["relative h-full"
                            (if (= id active-tab) "block" "hidden")]
                    :id              (str "panel-" name)
                    :role            "tabpanel"
                    :aria-labelledby name
                    :aria-hidden     (not= id active-tab)}
              (when (= id active-tab)
                [:f> fl.dag/dag-ui {:dag-id id}])]))]))


(defn panes-manager []
  [:f> editor-pane {:pane-id :main-pane}])

